import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { succsesDataAddAlert, succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import moment from "moment";
import { useSelector } from "react-redux";

const Managers = () => {
    const { id } = useParams();

    const PingPermissions = useSelector((state) => state.status.permissions);

    const [managersList, setManagersList] = useState([]);

    const { data: users, refetch: refetchUsers } = useGetPageQuery("users?per_page=9999&active=" + id);
    const [deleteUser, { isLoading, isError }] = useSendFormMutation();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setManagersList([...managersList, e.target.value]);
        } else if (!e.target.checked) {
            setManagersList([...managersList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteManagersHandler = async () => {
        for (const user of managersList) {
            await deleteUser({ body: {}, url: "users/" + user, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchUsers();
    };

    const checkAllHandler = () => {
        setManagersList(users.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetchUsers();
        };
        refetch();
    }, [users]);

    return (
        <div className="content">
            <div className="col-12">
                <div className="page-header d-flex justify-content-between align-items-center mb-3">
                    <div className="header">
                        <h1>Менеджери</h1>
                    </div>
                    <div className="page-header__button">
                        <div className="float-right">
                            <Link to={"/manager"} className="add btn btn-primary">
                                Додати менеджера
                            </Link>
                        </div>
                    </div>
                </div>
                <ul className="nav-bordered nav nav-tabs mb-3">
                    <li className="nav-item">
                        <Link to={"/managers/1"} className={+id === 1 ? "nav-link active" : "nav-link"}>
                            <span className=" d-lg-block">Активні</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/managers/0"} className={+id === 0 ? "nav-link active" : "nav-link"}>
                            <span className=" d-lg-block">Деактивовані</span>
                        </Link>
                    </li>
                </ul>
                <div id="list_form">
                    <a className="check_all" onClick={checkAllHandler}>
                        Виділити все
                    </a>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th data-field="check"></th>
                                <th data-field="id" className="no-mobile">
                                    ID
                                </th>
                                <th data-field="user_name">Менеджер</th>
                                <th data-field="user_login">Email</th>
                                <th data-field="user_role">Відділ</th>
                                <th data-field="user_phone" className="no-mobile">
                                    Телефон
                                </th>
                                <th data-field="user_status" className="no-mobile">
                                    Статус
                                </th>
                                <th data-field="user_date" className="no-mobile">
                                    Останній вхід
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {users &&
                                users.data.map((user) => {
                                    return (
                                        <tr key={user.id}>
                                            <td className="check_area text-right">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={managersList.includes(user.id.toString())}
                                                        value={user.id}
                                                        onChange={(e) => listCheckHandler(e)}
                                                    />
                                                    <label className="custom-control-label">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td className="no-mobile">#{user.id}</td>
                                            <td>
                                                <Link to={"/manager/" + user.id}>{user.name}</Link>
                                            </td>
                                            <td>{user.email}</td>
                                            <td>{user.permission_type.title}</td>
                                            <td className="no-mobile">{user.phone}</td>
                                            <td className="no-mobile">{user.active ? "Активний" : "Деактивований"}</td>
                                            <td className="no-mobile">
                                                {user?.last_enter
                                                    ? moment(user.last_enter).format("DD.MM.YYYY HH:MM")
                                                    : "-"}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    {PingPermissions.includes("user_edit") || PingPermissions.includes("all") ? (
                        <div className="d-flex">
                            <select name="action" className="form-select" style={{ width: "auto" }}>
                                <option value="delete">Видалити</option>{" "}
                            </select>
                            <button className="btn btn-info mx-3" onClick={deleteManagersHandler}>
                                {isLoading ? "Завантаження" : "Виконати"}
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Managers;
